export default "__VITE_ASSET__CskajUUA__"